"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var config_1 = tslib_1.__importDefault(require("../../../../utilities/config"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../theme/styled-components"));
var FADED_COLOR = '#7f7f7f';
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  font-size: ", ";\n  margin-bottom: ", ";\n"], ["\n  text-align: center;\n  font-size: ", ";\n  margin-bottom: ", ";\n"])), polished_1.rem(14), polished_1.rem(8));
var CompetitionName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-weight: bold;\n  > span {\n    font-weight: normal;\n    color: ", ";\n  }\n"], ["\n  font-weight: bold;\n  > span {\n    font-weight: normal;\n    color: ", ";\n  }\n"])), FADED_COLOR);
var EventDateTime = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), FADED_COLOR);
var EventName = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), FADED_COLOR);
var C = function (_a) {
    var competitionName = _a.competitionName, eventName = _a.eventName, eventDateTime = _a.eventDateTime;
    return (React.createElement(Wrapper, null,
        React.createElement(CompetitionName, null, competitionName),
        eventDateTime && (React.createElement(EventDateTime, null,
            date_fns_1.format(eventDateTime, config_1["default"].DEFAULT_DATE_FORMAT),
            " o",
            ' ',
            date_fns_1.format(eventDateTime, config_1["default"].DEFAULT_TIME_FORMAT))),
        eventName && React.createElement(EventName, null, eventName)));
};
exports["default"] = React.memo(C);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
